import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';

@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-facebook-post-details',
  templateUrl: './facebook-post-details.component.html',
})
export class FacebookPostDetailsComponent extends DeliverableAnalyticsContentDirective {}
